<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-xl-8">
          <navigation
            :list="lastFiveYears"
            :active-value="activeYear"
            variety="underline"
            @active:updated="updateActiveYear"
          />
        </div>
      </div>
      <div class="campus_recruiting_content_area row">
        <div
          v-if="recruitmentsGetter.length"
          class="col-12"
        >
          <campus-recruiting-index-card
            v-for="recruitment in recruitmentsGetter"
            :key="recruitment.recruitment_id"
            :recruitment="recruitment"
          />
        </div>
        <div
          v-else
          class="col-12 text-center"
        >
          今年尚未舉辦徵才活動
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <bootstrap-pagination
            v-if="pageGetter.page_total > 1"
            :total-page-number="pageGetter.page_total"
            @number:updated="updateRecruitingPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { lastFiveYearsStartFrom2020, lastFiveYearsStartFrom2019, thisYearNumber } from '~utils/date-time'
import CampusRecruitingIndexCard from './common/CampusRecruitingIndexCard'
import BootstrapPagination from '~bootstrap/Pagination'
import Navigation from '~components/common/Navigation'
export default {
  name: 'CampusRecruitingIndexContent',
  components: {
    CampusRecruitingIndexCard,
    BootstrapPagination,
    Navigation
  },
  data () {
    return {
      lastFiveYears:(thisYearNumber + 1 === 2025) ? lastFiveYearsStartFrom2020() : lastFiveYearsStartFrom2019 (),
      activeYear: (thisYearNumber + 1 === 2025) ? thisYearNumber + 1 : thisYearNumber
    }
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'recruitmentsGetter',
      'pageGetter'
    ])
  },
  async created () {
    await this.getAllRecruitments()
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getAllRecruitments'
    ]),
    updateActiveYear (year) {
      if (year) {
        this.activeYear = year
        this.getAllRecruitments({
          year
        })
      }
    },
    updateRecruitingPage (page) {
      this.getAllRecruitments({
        page,
        year: this.activeYear
      })
    }
  }
}
</script>
